import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "antd";
import useSettingstore from "../../store/settings.store";
import "./resumeResultsSearchSummary.scss";


function ResumeResultsSearchSummary({ pageResult }) {
  const navigate = useNavigate();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const previousValues = JSON.parse(getSettingByKey("resumeDB").value);

  const handleModify = () => {
    if(previousValues.minexp == -1) previousValues.minexp =""
    if(previousValues.maxexp == -1) previousValues.maxexp =""
    if(previousValues.noticeperiod == 1024) previousValues.noticeperiod ="" 
    if(previousValues.filter != undefined){
      if(previousValues.filter.minctc == -1) previousValues.filter.minctc =""
      if(previousValues.filter.maxctc == -1) previousValues.filter.maxctc ="" 
    }
   

    navigate("/resumes", { state: { previousValues } });
    addOrUpdateSetting({
      key: "rdbSearchView",
      value: true,
    });
  };

  return (
    <div className="resumeResultSearchSummary-wrapper">
      <div className="resumeResultsSearchSummary-title">
        Showing Results for Keywords
      </div>
      <div className="resumeResultsSearchSummary-keywords">
        {pageResult?.triggerreq?.skills.toUpperCase()}
      </div>
      <div className="resumeResultsSearchSummary-details-grid">
        <div className="resumeResultsSearchSummary-detail-item">
          Experience Range : <nsbp />
          <b>
            {pageResult?.triggerreq?.minexp > 0
              ? pageResult?.triggerreq?.minexp + " Yrs"
              : "Any"}
            -
            {pageResult?.triggerreq?.maxexp > 0
              ? pageResult?.triggerreq?.maxexp + " Yrs"
              : "Any"}
          </b>
        </div>
        <div className="resumeResultsSearchSummary-detail-item">
          Notice Period : <nsbp />
          <b>{pageResult?.triggerreq?.noticeperiod==1024?"Any":pageResult?.triggerreq?.noticeperiod + " days"}</b>
        </div>
        <div className="resumeResultsSearchSummary-detail-item">
          LWD Status : <b>{pageResult?.triggerreq?.filter.lwdstatus==""?"Any":pageResult?.triggerreq?.filter.lwdstatus}</b>
        </div>
        <div className="resumeResultsSearchSummary-detail-item">
          CTC Range : <nsbp />
          <b>
            {pageResult?.triggerreq?.filter.minctc > 0
              ? pageResult?.triggerreq?.filter.minctc + " LPA"
              : "Any"}
            -
            {pageResult?.triggerreq?.filter.maxctc > 0
              ? pageResult?.triggerreq?.filter.maxctc + " LPA"
              : "Any"}
          </b>
        </div>        
        <div className="resumeResultsSearchSummary-detail-item">
          Current location :<nsbp /> <b>{pageResult?.triggerreq?.filter.clocation==""?"Any":pageResult?.triggerreq?.filter.clocation}</b>
        </div>
        <div className="resumeResultsSearchSummary-detail-item">
          Preferred location :<nsbp /><b>{pageResult?.triggerreq?.plocation==""?" Any":pageResult?.triggerreq?.plocation}</b>
        </div>
      </div>
      <div className="resumeResultsSearchSummary-details">
        <Button className={""} onClick={() => handleModify()}>
          Modify Criteria
        </Button>
      </div>
    </div>
  );
}

export default ResumeResultsSearchSummary;
